export const START_REPORT_A_CLAIM = "START_REPORT_A_CLAIM";
export const CANCEL_REPORT_A_CLAIM = "CANCEL_REPORT_A_CLAIM";
export const REPORT_VALIDATION_STARTED = "REPORT_VALIDATION_STARTED";
export const REPORT_VALIDATION_SUCCEEDED = "REPORT_VALIDATION_SUCCEEDED";
export const REPORT_VALIDATION_FAILED = "REPORT_VALIDATION_FAILED";
